<template>
<div>
  <table class="table table-striped table-bordered">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Client</th>
        <th scope="col">Plan</th>
        <th scope="col">Program</th>
        <th scope="col">Check-in</th>
        <th scope="col">Status</th>
        <th scope="col">Sent</th>
        <th scope="col">Completed</th>
        <!-- <th scope="col">Response</th> -->
        <!-- <th scope="col">Coach</th> -->
        <th scope="col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="isLoading">
        <td colspan="9">
          <div class="text-center">
            <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </td>
      </tr>
      <tr v-else-if="checkins.length == 0">
        <td colspan="9">
          Nothing to see here. Nice job, coach!
        </td>
      </tr>
      <template v-else>
        <tr v-for="checkin in checkins" v-bind:key="checkin.id">
          <td scope="row">{{ checkin.id }}</td>
          <td>
            <a :href="'/coach/clients/'+checkin.plan.client.id">{{ checkin.plan.client.first_name }} {{ checkin.plan.client.last_name }}</a>
            <br>
            <small><a :href="'mailto:'+checkin.plan.client.email">{{ checkin.plan.client.email }}</a></small>
          </td>
          <td><a :href="'/coach/plans/'+checkin.plan.id">{{ checkin.plan.name }}</a></td>
          <td>{{ checkin.plan.program.name }}</td>
          <td>{{ checkin.coaching_program_checkin.name }}</td>
          <td>
            <checkin-status-badge :status="checkin.status"></checkin-status-badge>
          </td>
          <!-- <td scope="row"><checkin-status-badge-component :status="checkin.status"></checkin-status-badge-component></td> -->
          <td>{{ checkin.sent_at | moment("from", "now") }}</td>
          <td>{{ checkin.completed_at | moment("from", "now") }}</td>
          <td>
            <button v-if="!isCompleted(checkin)" @click="previewCheckinEmail(checkin)" class="btn btn-sm btn-secondary"><i class="mdi mdi-email-outline"></i> Preview/Send</button>
            <button v-if="isPendingReview(checkin) || isReviewed(checkin)" @click="openCheckinFeedbackModal(checkin)" class="btn btn-sm btn-primary"><i class="mdi mdi-message"></i> Review</button>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
  <checkin-preview-modal
    :show="showPreviewModal"
    :checkin="previewCheckin"
    @close="previewModalClosed()"
    @checkinEmailSent="checkinEmailSent"
  ></checkin-preview-modal>
  <checkin-feedback-modal
    :show="showCheckinFeedbackModal"
    :checkin_id="checkinToSendFeedbackId"
    @close="checkinFeedbackModalClosed()"
    @checkinUpdated="feedbackSubmitted"
  ></checkin-feedback-modal>
</div>
</template>
<script>
export default {
  props: [
    'initialCheckins',
    'isLoading'
  ],
  data() {
    return {
      checkinToSendFeedback: null,
      showCheckinFeedbackModal: false,
      previewCheckin: null,
      showPreviewModal: false,
      checkins: this.initialCheckins,
    }
  },
  computed: {
    checkinToSendFeedbackId: function() {
      return this.checkinToSendFeedback?.id ?? null;
    },
  },
  methods: {
    feedbackSubmitted: function(checkin) {
      console.log("Feedback submitted for checkin! " + checkin.id);
      // update it.
      this.mergeCheckinData(checkin);
      this.checkinFeedbackModalClosed();
    },
    openCheckinFeedbackModal: function(checkin) {
      // console.log("openCheckinFeedbackModal " + checkin.id);
      this.showCheckinFeedbackModal = true;
      this.checkinToSendFeedback = checkin;
    },
    checkinFeedbackModalClosed: function() {
      // console.log("checkinFeedbackModalClosed");
      this.showCheckinFeedbackModal = false;
      this.checkinToSendFeedback = null;
    },
    previewCheckinEmail: function(checkin) {
      this.previewCheckin = checkin;
      this.showPreviewModal=true;
    },
    checkinEmailSent: function(checkin) {
      this.mergeCheckinData(checkin);
      this.previewModalClosed();
    },
    previewModalClosed: function() {
      this.previewCheckin = null;
      this.showPreviewModal = false;
    },
    mergeCheckinData: function(checkinData) {
      // update local
      this.checkins = this.checkins.map(function(checkin) {
        if (checkin.id == checkinData.id) {
          return mergeObj(checkin, checkinData);
        }
        return checkin;
      });
    },
    isCompleted: function (checkin) {
      if (checkin.completed_at) {
        return true;
      }
      return false;
    },
    isPendingReview: function (checkin) {
      return checkin.status == 'pending_review';
    },
    isReviewed: function (checkin) {
      return checkin.status == 'reviewed';
    },
  },
  filters: {
  },
  watch: {
    initialCheckins: function (newVal, oldVal) {
      Vue.set(this, 'checkins', newVal);
    },
    isLoading: function (newVal, oldVal) {
      Vue.set(this, 'isLoading', newVal);
    }
  }
}
</script>
<style></style>
